import { render, staticRenderFns } from "./ChannelDataIntegrations.vue?vue&type=template&id=3498822d&scoped=true"
import script from "./ChannelDataIntegrations.vue?vue&type=script&lang=js"
export * from "./ChannelDataIntegrations.vue?vue&type=script&lang=js"
import style0 from "./ChannelDataIntegrations.vue?vue&type=style&index=0&id=3498822d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3498822d",
  null
  
)

export default component.exports